<template>
  <div class="align-horizontal indicator_wrapper">
    <div v-for="dot in length" class="indicator" :class="{'active':dot == active + 1}">
    </div>
  </div>

</template>

<script>
export default {
  name: "CarouselIndicator",
  props:{
    length: {
      type: [Number, String],
      default: 0
    },
    active: {
      type: [Number, String],
      default: 0,
    }
  },
  computed: {
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/css/vars";
  .active {
    background-color: #88bdfc !important;
  }
  .indicator {
    width: 8px;
    height: 8px;
    margin: 3px;
    border-radius: 100%;
    background-color: #d4dddb;
  }
  .indicator_wrapper {
    position: absolute;
    display: flex;
    justify-content: center;
    left: 0;
    right: 0;
    bottom: 20px;
  }
</style>


// WEBPACK FOOTER //
// src/components/controls/CarouselIndicator.vue